import styled from 'styled-components';

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;

  &:hover {
    cursor: pointer;
  }
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ItemContainer = styled.div`

`;

export const ItemLabel = styled.p`
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0;
`;

export const ItemText = styled.p`
  font-size: 1rem;
  margin: 0;
`;